import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import { t } from "@/i18n";
import { useDispatch } from "react-redux";
import { USER_SAVE } from "@/actions/types";
import { fromJS } from "immutable";
import { setLanguage } from "@/actions/i18n.actions";
const useUpdateUser = (userId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updateUser", userId],
    mutationFn: (payload) => {
      if (userId === "me" && payload?.siteSettings?.language) {
        setLanguage(payload.siteSettings.language);
      }
      return apiClient.put(`users/${userId}`, payload);
    },
    onSuccess: (mutationResponse) => {
      if (userId === "me") {
        queryClient.setQueryData(["me"], mutationResponse);
      } else {
        queryClient.setQueryData(["users", userId], mutationResponse);
      }

      dispatch({ type: USER_SAVE, payload: fromJS(mutationResponse.data) }); // Save to redux store (legacy for as long as needed)
    },
    onError: () => {
      notify("error", t("generic.unknown_error"));
    },
  });
};

export { useUpdateUser };
